import { useState, useEffect } from 'react'

import { toast } from 'react-toastify'

import { useMe } from '../contexts/me'

import { makeMe } from '../../main/usecases/me/load-me-factory'
import { makeUsers } from '../../main/usecases/users/remote-users-factory'

import isHttpError from '../helpers/helper-http-error'

export const useFirstAccess = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { me, updateMe } = useMe()

  useEffect(() => {
    if (me) {
      setIsModalOpen(me.firstAccess)
    }
  }, [me])

  const handleModalClose = async () => {
    try {
      await makeUsers().updateFirstAccess()

      const updatedMe = await makeMe().load()
      updateMe(updatedMe)
    } catch (error) {
      const httpError = isHttpError(error)

      if (httpError) {
        toast.error(httpError.message)
      } else {
        throw error
      }
    }
  }

  return {
    isModalOpen,
    handleModalClose,
  }
}
